function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $fnLeV$react = require("react");
var $fnLeV$reactdom = require("react-dom");
var $fnLeV$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $fnLeV$radixuireactuselayouteffect = require("@radix-ui/react-use-layout-effect");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "Presence", function () {
  return $a2fa0214bb2735a1$export$99c2b779aa4e8b8b;
});
function $8f63844556d0d3cd$export$3e6543de14f8614f(initialState, machine) {
  return $fnLeV$react.useReducer(function (state, event) {
    var nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
var $a2fa0214bb2735a1$export$99c2b779aa4e8b8b = function $a2fa0214bb2735a1$export$99c2b779aa4e8b8b(props) {
  var present = props.present,
    children = props.children;
  var presence = $a2fa0214bb2735a1$var$usePresence(present);
  var child = typeof children === 'function' ? children({
    present: presence.isPresent
  }) : $fnLeV$react.Children.only(children);
  var ref = $fnLeV$radixuireactcomposerefs.useComposedRefs(presence.ref, child.ref);
  var forceMount = typeof children === 'function';
  return forceMount || presence.isPresent ? /*#__PURE__*/$fnLeV$react.cloneElement(child, {
    ref: ref
  }) : null;
};
$a2fa0214bb2735a1$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/
function $a2fa0214bb2735a1$var$usePresence(present) {
  var _$fnLeV$react$useStat = $fnLeV$react.useState(),
    _$fnLeV$react$useStat2 = _slicedToArray(_$fnLeV$react$useStat, 2),
    node1 = _$fnLeV$react$useStat2[0],
    setNode = _$fnLeV$react$useStat2[1];
  var stylesRef = $fnLeV$react.useRef({});
  var prevPresentRef = $fnLeV$react.useRef(present);
  var prevAnimationNameRef = $fnLeV$react.useRef('none');
  var initialState = present ? 'mounted' : 'unmounted';
  var _$8f63844556d0d3cd$ex = $8f63844556d0d3cd$export$3e6543de14f8614f(initialState, {
      mounted: {
        UNMOUNT: 'unmounted',
        ANIMATION_OUT: 'unmountSuspended'
      },
      unmountSuspended: {
        MOUNT: 'mounted',
        ANIMATION_END: 'unmounted'
      },
      unmounted: {
        MOUNT: 'mounted'
      }
    }),
    _$8f63844556d0d3cd$ex2 = _slicedToArray(_$8f63844556d0d3cd$ex, 2),
    state = _$8f63844556d0d3cd$ex2[0],
    send = _$8f63844556d0d3cd$ex2[1];
  $fnLeV$react.useEffect(function () {
    var currentAnimationName = $a2fa0214bb2735a1$var$getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
  }, [state]);
  $fnLeV$radixuireactuselayouteffect.useLayoutEffect(function () {
    var styles = stylesRef.current;
    var wasPresent = prevPresentRef.current;
    var hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      var prevAnimationName = prevAnimationNameRef.current;
      var currentAnimationName = $a2fa0214bb2735a1$var$getAnimationName(styles);
      if (present) send('MOUNT');else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none')
        // If there is no exit animation or the element is hidden, animations won't run
        // so we unmount instantly
        send('UNMOUNT');else {
        /**
        * When `present` changes to `false`, we check changes to animation-name to
        * determine whether an animation has started. We chose this approach (reading
        * computed styles) because there is no `animationrun` event and `animationstart`
        * fires after `animation-delay` has expired which would be too late.
        */
        var isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send('ANIMATION_OUT');else send('UNMOUNT');
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  $fnLeV$radixuireactuselayouteffect.useLayoutEffect(function () {
    if (node1) {
      /**
      * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
      * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
      * make sure we only trigger ANIMATION_END for the currently active animation.
      */
      var handleAnimationEnd = function handleAnimationEnd(event) {
        var currentAnimationName = $a2fa0214bb2735a1$var$getAnimationName(stylesRef.current);
        var isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation)
          // With React 18 concurrency this update is applied
          // a frame after the animation ends, creating a flash of visible content.
          // By manually flushing we ensure they sync within a frame, removing the flash.
          $fnLeV$reactdom.flushSync(function () {
            return send('ANIMATION_END');
          });
      };
      var handleAnimationStart = function handleAnimationStart(event) {
        if (event.target === node1)
          // if animation occurred, store its name as the previous animation.
          prevAnimationNameRef.current = $a2fa0214bb2735a1$var$getAnimationName(stylesRef.current);
      };
      node1.addEventListener('animationstart', handleAnimationStart);
      node1.addEventListener('animationcancel', handleAnimationEnd);
      node1.addEventListener('animationend', handleAnimationEnd);
      return function () {
        node1.removeEventListener('animationstart', handleAnimationStart);
        node1.removeEventListener('animationcancel', handleAnimationEnd);
        node1.removeEventListener('animationend', handleAnimationEnd);
      };
    } else
      // Transition to the unmounted state if the node is removed prematurely.
      // We avoid doing so during cleanup as the node may change but still exist.
      send('ANIMATION_END');
  }, [node1, send]);
  return {
    isPresent: ['mounted', 'unmountSuspended'].includes(state),
    ref: $fnLeV$react.useCallback(function (node) {
      if (node) stylesRef.current = getComputedStyle(node);
      setNode(node);
    }, [])
  };
}
/* -----------------------------------------------------------------------------------------------*/
function $a2fa0214bb2735a1$var$getAnimationName(styles) {
  return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}